export class UrlUtils {

  static getDomainIfExists(): string | null {
    const hostname = window.location.hostname;
    if (hostname) {
      const urlArray = hostname.split('.');
      if (urlArray?.length >= 3) {
        return urlArray[0];
      }
    }
    return null;
  }

}
